import type { CardInput } from '~/services/modules/paymentGateway/tokenizeCard';
import type { CardBrand } from '~/utils/creditCard';
import type { BrazilAddressFields } from '~/utils/brazilAddress';

/** Cartão salvo do cliente (`GET Customers/{id}/cards`), já com a bandeira normalizada. */
export type JourneySavedCard = {
  id: string;
  brand: CardBrand;
  lastFour: string;
};

/**
 * Cartão novo validado no gateway («Adicionar cartão»). O token do Pagar.me dura 60 s e é de uso único, então
 * os dados ficam **só em memória** (nunca em storage) para gerar um token novo a cada pagamento.
 */
export type JourneyAddedCard = JourneySavedCard & {
  cardInput: CardInput;
  billingAddress: BrazilAddressFields;
};

/** Valor do seletor para «Novo cartão de crédito». */
export const NEW_CARD_OPTION = 'new';
